import { ReactElement } from 'react';

import { Address } from '@dreryk/address-common-api';

import { addressFormatter } from '@dreryk/react-common';
import { MapMarkerIcon, Tooltip, TooltipLabel, TooltipPlacement, TooltipTrigger } from '@dreryk/react-components';

import { visitTranslationKeys } from '../../translations';

type VisitLocationTooltipContentProps = {
   readonly name: string;
   readonly address: Address;
};

const VisitLocationTooltipContent = (props: VisitLocationTooltipContentProps): JSX.Element => {
   return (
      <div>
         <TooltipLabel icon={<MapMarkerIcon />} label={visitTranslationKeys.serviceProvidingLocation} />
         <div>{props.name}</div>
         {addressFormatter(props.address)}
      </div>
   );
};

type VisitLocationTooltipProps = {
   readonly children: ReactElement;
   readonly name: string | undefined;
   readonly address: Address | undefined;
};

export const VisitLocationTooltip = (props: VisitLocationTooltipProps): JSX.Element => {
   if (!props.name || !props.address) {
      return props.children;
   }

   return (
      <Tooltip
         placement={TooltipPlacement.RIGHT}
         trigger={TooltipTrigger.HOVER}
         maxWidth='300px'
         content={<VisitLocationTooltipContent name={props.name} address={props.address} />}
         testId={'visitLocation'}
      >
         {props.children}
      </Tooltip>
   );
};
